import { useTRPC } from "../../../../trpc/client";
import { useQueryClient, useMutation } from "@tanstack/react-query";

export function useRetryErpSync(
  onSuccess: () => void,
  onError: (error: unknown) => void
) {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  const retryErpSyncMutation = useMutation({
    ...trpc.invoices.retryErpSync.mutationOptions(),
    onSuccess,
    onError,
  });

  const retryErpSync = (
    merchantid: string,
    invoiceId: string,
    callbacks?: { onSettled?: () => void }
  ) => {
    retryErpSyncMutation.mutate(
      { rentalsMerchantId: merchantid, id: invoiceId },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({ queryKey: trpc.invoices.list.queryKey() });
          setTimeout(() => callbacks?.onSettled?.(), 10000);
        },
        onError: () => {
          callbacks?.onSettled?.();
        },
      }
    );
  };

  return { retryErpSync };
}
